import { render, staticRenderFns } from "./NotificationSet.vue?vue&type=template&id=25c26654&"
import script from "./NotificationSet.vue?vue&type=script&lang=js&"
export * from "./NotificationSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports